import { AppProps as NextAppProps } from 'next/app';
import Script from 'next/script';
import React from 'react';

import { initMSW } from '../cypress/msw';
import { HeaderContent } from '../lib/api/types';
import HeaderContextProvider from '../lib/HeaderContextProvider';
import * as appConfig from '../server/config/app.config';
import { Error, ErrorProps, isErrorProps } from '../src/error/Error';

import '../lib/theme/variables.scss';

type AppProps<P = any> = {
    pageProps: P;
} & Omit<NextAppProps<P>, 'pageProps'>;

if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    initMSW();
}

export default function App({
    Component,
    pageProps,
}: AppProps<HeaderContent | ErrorProps>): JSX.Element {
    if (isErrorProps(pageProps)) {
        return (
            <Error
                errorCode={pageProps.errorCode}
                errorMessage={pageProps.errorMessage}
            />
        );
    }

    const contentCDN = String(appConfig.getConfig().cdn.contentCDN);
    const vendorAssetManagerCDN = `${contentCDN}/media/vendor-assets-manager`;

    return (
        <>
            <Script
                src={`${vendorAssetManagerCDN}/js/shop/events-bus.js`}
                strategy="beforeInteractive"
            />
            <HeaderContextProvider content={pageProps}>
                <Component {...pageProps} />
            </HeaderContextProvider>
        </>
    );
}
